const config = {
  baseURL : "https://api.pharmacrowd.net",
  getAllNews: "news/getAllnews",
  coin_detail_base_url: "https://bscscan.com/address/contract_address/",

  // BSC chain: 'testnet' | 'mainnet'
  BSC_CHAIN: "testnet",
  BSC_EXPLORER_TX: {
    testnet: "https://testnet.bscscan.com/tx/",
    mainnet: "https://bscscan.com/tx/",
  },
};

export const getBscTxUrl = (hash) =>
  `${config.BSC_EXPLORER_TX[config.BSC_CHAIN]}${hash}`;

export default config;
